const l = (e) => e instanceof HTMLIFrameElement, u = (e, n) => {
  e.document.readyState === "complete" ? n() : e.addEventListener("load", n);
}, f = (e, n) => {
  n(), e.addEventListener("load", n);
}, g = () => ({ offsetSize: 0, checkOrigin: !0, enableLegacyLibSupport: !1 }), m = (e) => {
  try {
    const n = new URL(e.src).origin;
    if (n !== "about:blank")
      return n;
  } catch {
  }
  return null;
}, h = (e) => (Object.keys(e).forEach((n) => e[n] === void 0 && delete e[n]), e), b = (e) => {
  const { height: n } = e.documentElement.getBoundingClientRect() ?? {};
  return n ? Math.ceil(n) : void 0;
};
function k(e) {
  f(
    e,
    () => {
      var n;
      return (n = e.contentWindow) == null ? void 0 : n.postMessage("[iFrameSizer]ID:0:false:false:32:true:true::auto:::0:false:child:auto:true:::true:::false", "*");
    }
  );
}
function p(e) {
  if (typeof e.data == "string" && e.data.startsWith("[iFrameSizer]")) {
    const [n, r] = e.data.split(":"), o = +r;
    return o > 0 ? o : null;
  }
  return null;
}
const O = (e, n) => {
  const r = {
    ...g(),
    ...h(e ?? {})
  }, o = w(n), i = L(r, o);
  return o.map((a) => {
    r.debug && console.log("ifr", "register iframe", a);
    const c = y(
      a,
      r,
      i
    );
    return {
      unsubscribe: () => {
        r.debug && console.log("ifr", "unregister iframe", a), c();
      }
    };
  });
};
function w(e) {
  return typeof e == "string" ? Array.from(document.querySelectorAll(e)).filter(
    l
  ) : e ? l(e) ? [e] : [] : Array.from(document.getElementsByTagName("iframe"));
}
function L(e, n) {
  if (Array.isArray(e.checkOrigin))
    return e.checkOrigin;
  if (!e.checkOrigin)
    return [];
  const r = [];
  for (const o of n) {
    const i = m(o);
    i && r.push(i);
  }
  return r;
}
function y(e, n, r) {
  return z(e, n, r);
}
function z(e, n, r) {
  const o = (i) => {
    var s;
    n.onMessageReceavedCallback && n.onMessageReceavedCallback(i);
    const a = !n.checkOrigin || r.includes(i.origin), c = e.contentWindow === i.source;
    if (!c || !a) {
      n.onUnknownEventCallback && n.onUnknownEventCallback({
        event: i,
        isOriginValid: a,
        isIframeTarget: c,
        checkOrigin: n.checkOrigin,
        allowedOrigins: r,
        contentWindow: e.contentWindow,
        source: i.source
      });
      return;
    }
    if (((s = i.data) == null ? void 0 : s.type) === "iframe-resized") {
      const { height: t } = i.data;
      n.onHeightReceavedCallback && n.onHeightReceavedCallback(t, i), t && d({ height: t, iframe: e, settings: n });
      return;
    }
    if (n.onUnknownEventCallback && n.onUnknownEventCallback(i), n.enableLegacyLibSupport) {
      const t = p(i);
      t !== null && d({ height: t, iframe: e, settings: n });
      return;
    }
  };
  return window.addEventListener("message", o), n.enableLegacyLibSupport && k(e), () => window.removeEventListener("message", o);
}
function d({
  height: e,
  iframe: n,
  settings: r
}) {
  r.onSetIframeSizeCallback && r.onSetIframeSizeCallback(e, n), n.style.height = `${e + r.offsetSize}px`;
}
function S(e) {
  u(window, () => {
    const n = () => {
      let o = {
        type: "iframe-resized",
        width: document.documentElement.scrollWidth,
        height: b(document) ?? void 0
      };
      e != null && e.onBeforeMessageSend && (o = e.onBeforeMessageSend(o, window.parent)), window.parent.postMessage(o, "*");
    };
    new ResizeObserver(n).observe(document.body);
  });
}
export {
  O as initialize,
  S as initializeChildListener
};
